import React, { useEffect, useState } from 'react';
export default function ActiveFilters({ toggleMenu, labels, setCheckedFilters, filters, visible }) {
    const [mappedLabels, setMappedLabels] = useState();
    useEffect(() => {
        var _a, _b;
        const mappedData = (_b = (_a = labels === null || labels === void 0 ? void 0 : labels.terms) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b.map((label) => {
            return {
                label: label.name,
                id: label.databaseId,
            };
        });
        setMappedLabels(mappedData);
    }, [labels]);
    const filterItems = (filterId) => {
        const filteredData = filters === null || filters === void 0 ? void 0 : filters.filter((item) => {
            return item !== filterId;
        });
        setCheckedFilters(filteredData);
    };
    if (!visible)
        return;
    return (React.createElement("div", { className: 'ltg-mobile-filters' },
        React.createElement("div", { className: 'ltg-mobile-filters-wrap' },
            React.createElement("div", { className: 'ltg-mobile-filters-wrap-toggler' },
                React.createElement("button", { type: 'button', className: 'ltg-mobile-filters-wrap-toggler-button', onClick: () => {
                        toggleMenu();
                    } },
                    React.createElement("span", { className: "sr-only" }, "Filtrai"),
                    React.createElement("i", { className: "fas fa-filter" }))),
            React.createElement("div", { className: 'ltg-mobile-filters-wrap-list' }, filters.length > 0 && mappedLabels ? filters.map((item) => {
                const label = mappedLabels === null || mappedLabels === void 0 ? void 0 : mappedLabels.filter((label) => {
                    return label.id === item;
                });
                return (React.createElement(FilterItem, { id: item, key: item, label: label[0].label, handleDelete: (e) => {
                        filterItems(e);
                    } }));
            }) : null))));
}
;
export const FilterItem = function FiltersItem({ label, handleDelete, id }) {
    return (React.createElement("div", { className: 'ltg-mobile-filters-list-item' },
        React.createElement("span", { className: 'ltg-mobile-filters-list-item-title' }, label),
        React.createElement("button", { type: 'button', className: "ltg-mobile-filters-list-item-button", onClick: () => { handleDelete(id); } },
            React.createElement("i", { className: 'fas fa-times-circle' }))));
};
